import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { media } from '../../../../styles/base';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    badgeIcon: {
      margin: '0 20px 0 15px',
    },
    bathroomsFilterContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '15px 0px',
    },
    bathroomsFilterTitle: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
    },
    bedroomsFilterTitle: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
    },
    bedroomsFilterContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 24,
    },
    buttonGroup: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      width: 130,
    },
    buttonSeparator: {
      borderTop: '1px solid #E7E7E7',
      display: 'flex',
      justifyContent: 'space-between',
      margin: 0,
      padding: '10px 20px',
    },
    buttonWidth: {
      width: 70,
    },
    counterText: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
      textAlign: 'center',
    },
    daysOnMarketFilterContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid rgba(189, 189, 189, 0.3)',
      padding: '12px 0px',
      [media.mobile]: {
        padding: '16px 0px',
        paddingTop: '24px',
      },
    },
    daysOnMarketDropDown: {
      color: '#323232',
      fontSize: '14px',
      lineHeight: '17px',
      minWidth: 181,
      paddingRight: 10,
      borderRadius: 10,
      border: '1px solid #BDBDBD',
    },
    daysOnMarketFilterTitle: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
    },
    divider: {
      backgroundColor: 'grey',
      height: '1px',
      margin: '10px 0',
    },
    filterButton: {
      borderRadius: '30px',
      maxHeight: '40px',
      marginRight: '16px',
      border: '1px solid rgba(189, 189, 189, 1)',
      padding: '8px',
      [media.mobile]: {
        marginRight: '8px',
      },
    },
    filterButtonActive: {
      borderRadius: '30px',
      maxHeight: '40px',
      marginRight: '16px',
      border: '2px solid #463264',
      padding: '8px',
    },
    filterButtonText: {
      display: 'block',
      color: 'rgba(50, 50, 50, 1)',
      fontSize: '16px',
      lineHeight: '19.2px',
      textTransform: 'none',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      textAlign: 'left',
      minWidth: '100px',
      marginRight: '10px',
      margin: '-2px 10px 0px 5px',
      [media.tablet]: {
        margin: '-2px 10px 0px 5px',
        minWidth: 'auto',
      },
      [media.mobile]: {
        margin: '-2px 10px 0px 5px',
        minWidth: 'auto',
      },
    },
    filterButtonRoomCondition: {
      marginRight: 'auto',
      [media.tablet]: {
        marginRight: '16px!important',
      },
      [media.mobile]: {
        marginRight: '16px!important',
      },
    },
    filtersContainer: {
      backgroundColor: 'white',
      width: '100%',
    },
    filtersGroupOne: {
      display: 'flex',
      [media.mobile]: {
        paddingLeft: '16px',
      },
    },
    filtersGroupTwo: {
      display: 'flex',
      flex: 1,
      [media.mobile]: {
        paddingRight: '16px',
      },
    },
    filterDialog: {
      margin: '0px 16px',
      width: '100%',
    },
    filterHeader: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
    },
    filterHeading: {
      fontWeight: 700,
      fontSize: 21,
      lineHeight: '25.2px',
    },
    filterNavigation: {
      height: 50,
      margin: '24px 0px',
      width: '100%',
    },
    filterPage: {
      height: 420,
      marginBottom: 24,
    },
    filterSeparator: {
      marginBottom: '10px',
      padding: '0 20px',
    },
    filterSeparator1: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 20px 10px',
    },
    filterSeparatorWithDivider: {
      padding: '20px 20px',
    },
    formControl: {
      [media.mobile]: {
        width: 100,
        margin: 8,
      },
      margin: theme.spacing(1),
      width: 120,
    },
    garageSpaceContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid rgba(189, 189, 189, 0.3)',
      padding: '12px 0px',
      [media.mobile]: {
        padding: '16px 0px',
      },
    },
    garageSpaceTitle: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
    },
    highlightContainer: {
      display: 'flex',
    },
    highlightLabel: {
      backgroundColor: '#e2658c',
      borderRadius: 12,
      color: 'white',
      fontSize: 12,
      height: 25,
      marginLeft: 10,
      marginTop: 5,
      padding: '4px 10px',
    },
    maxDropDown: {
      color: '#323232',
      fontSize: '14px',
      lineHeight: '17px',
      minWidth: 215,
    },
    maxHOAFilterContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid rgba(189, 189, 189, 0.3)',
      padding: '12px 0px',
      [media.mobile]: {
        padding: '16px 0px',
      },
    },
    maxHOAFilterTitle: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
    },
    maxHOADropDown: {
      color: '#323232',
      fontSize: '14px',
      lineHeight: '17px',
      minWidth: 181,
      borderRadius: 10,
      border: '1px solid #BDBDBD',
      paddingRight: 10,
    },
    maxSqFeetDropDown: {
      color: '#323232',
      fontSize: '14px',
      lineHeight: '17px',
      minWidth: 181,
      width: '100%',
      borderRadius: 10,
      border: '1px solid #BDBDBD',
      paddingRight: 10,
    },
    openHouseContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0px',
      paddingTop: '12px',
    },
    openHouseTitle: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
    },
    padTop: {
      color: '#323232',
      fontSize: '12px',
      fontWeight: 'bold',
      height: '17px',
      lineHeight: '15px',
      paddingTop: 10,
      textTransform: 'capitalize',
    },
    parkingFilterContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid rgba(189, 189, 189, 0.3)',
      padding: '12px 0px',
      [media.mobile]: {
        padding: '16px 0px',
      },
    },
    parkingFilterTitle: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
    },
    filterFormContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 24,
    },
    filterFormSeparator: {
      color: '#323232',
      fontSize: 24,
      fontWeight: 700,
      lineHeight: '28.8px',
      margin: '0px 24px',
    },
    priceFilterTitle: {
      color: '#323232',
      fontSize: 18,
      fontWeight: 'bold',
      lineHeight: '21.6px',
    },
    priceForm: {
      [media.mobile]: {
        alignItems: 'center',
        display: 'flex',
      },
    },
    filterFormControl: {
      [media.mobile]: {
        width: 145,
      },
      width: 182,
      paddingRight: 10,
      borderRadius: 5,
      border: '1px solid #BDBDBD',
    },
    priceFormControl: {
      [media.mobile]: {
        margin: 8,
        width: 100,
      },
      margin: theme.spacing(1),
      width: 100,
    },
    propertyFilter: {
      marginTop: 24,
    },
    propertyFilterTitle: {
      color: '#323232',
      fontSize: 18,
      fontWeight: 700,
      lineHeight: '21.6px',
    },
    propertyLabel: {
      marginBottom: 24,
    },
    propertyValues: {
      [media.mobile]: {
        height: '20px',
      },
      fontSize: '14px',
      height: '40px',
      lineHeight: '17px',
      textAlign: 'center',
      textTransform: 'capitalize',
      width: '62px',
    },
    resetFilters: {
      color: '#323232',
      fontSize: '16px',
      fontWeight: 'bold',
      height: '19px',
      lineHeight: '19px',
      width: '88px',
    },
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      margin: '0px 1.5rem',
      height: '100%',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      [media.tablet]: {
        margin: '0px 1rem',
      },
      [media.mobile]: {
        margin: 0,
      },
    },
    rootContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    selectedBox: {
      backgroundColor: '#463264 !important',
      color: 'white',
    },
    selectedButton: {
      borderLeft: '1px solid #E7E7E7 !important',
      [media.mobile]: {
        width: '58px',
      },
      '&:hover': {
        backgroundColor: '#463264',
      },
      backgroundColor: '#463264 !important',
      color: '#FFFF !important',
      height: 30,
      width: 62,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    shareButton: {
      fontSize: '16px',
      fontWeight: 'bold',
      marginLeft: 10,
      textTransform: 'capitalize',
    },
    sqFeetFilterTitle: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
    },
    sqFeetFilterContainer: {
      [media.mobile]: {
        alignItems: 'center',
        display: 'flex',
      },
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '15px 0px',
    },
    title: {
      color: '#323232',
      fontSize: '12px',
      fontWeight: 'bold',
      height: '17px',
      lineHeight: '15px',
      textTransform: 'capitalize',
      width: '88px',
    },
    toggleButton: {
      border: '1px solid #BDBDBD',
      borderRadius: 5,
      height: 35,
      width: 90,
      [media.tabletAndDesktop]: {
        width: 60,
      },
    },
    toggleButtonSwiper: {
      border: '1px solid #BDBDBD',
      borderRadius: 5,
      height: 35,
      width: 90,
    },
    toggleButtonText: {
      margin: 0,
      paddingLeft: 5,
      textTransform: 'capitalize',
      fontSize: 16,
      [media.tabletAndDesktop]: {
        fontSize: 14,
      },
    },
    toggleContainer: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: 190,
      [media.tabletAndDesktop]: {
        width: 135,
      },
    },
    toggleContainerSwiper: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingLeft: 15,
      paddingRight: 15,
      width: 215,
    },
    unSelectedBox: {
      backgroundColor: '#FFFF',
      color: 'black',
    },
    unSelectedButton: {
      borderLeft: '1px solid #E7E7E7 !important',
      [media.mobile]: {
        width: '58px',
      },
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
      },
      backgroundColor: '#FFFF',
      color: '#000000',
      height: 30,
      width: 62,
    },
    values: {
      fontSize: '14px',
      lineHeight: '17px',
      textAlign: 'center',
      textTransform: 'capitalize',
      width: '62px',
    },
    yearControl: {
      width: 100,
      borderRadius: 10,
      border: '1px solid #BDBDBD',
      paddingRight: 10,
    },
    yearFilterContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 0px',
      borderBottom: '1px solid rgba(189, 189, 189, 0.3)',
      [media.mobile]: {
        alignItems: 'center',
        padding: '16px 0px',
      },
    },
    yearFilterDropdown: {
      display: 'flex',
      alignItems: 'center',
    },
    yearFilterTitle: {
      color: '#323232',
      fontSize: 18,
      lineHeight: '21.6px',
    },
    yearFilterSeparator: {
      color: '#323232',
      fontSize: 24,
      fontWeight: 700,
      lineHeight: '28.8px',
      margin: '0px 8px',
    },
  }),
);

export default styles;
